import type { ToastColor } from '~~/layers/base/types/commonTypes'
import type {
    Color,
    Font,
    Print,
    ElementsConfiguration,
} from '~~/layers/base/types/productPartConfiguration'

// NUXTUI-COMPONENT IMPORT
const toast = useToast()

// Show notification method
export const showToastNotification = ({
    title,
    description,
    color,
}: {
    title: string
    description: string
    color: ToastColor
}): void => {
    toast.add({
        title: title,
        description: description,
        color: color,
    })
}

export const createExpressObjectForPart = (elements: ElementsConfiguration[]) => {
    const expressObject = { liner: null, paper: null, print: [], color: [], font: [] }
    if (elements?.length) {
        const prints: Print[] = []
        const colors: Color[] = []
        const fonts: Font[] = []
        for (let e = 0; e < elements.length; e++) {
            const currentElement = elements[e]
            // print
            if (currentElement!.print) {
                const isDuplicate = prints.some(
                    (item: Print) => item.processId === currentElement!.print!.processId
                )
                if (!isDuplicate) {
                    prints.push(currentElement!.print)
                }
            }
            // color
            if (currentElement!.color) {
                const isDuplicate = colors.some(
                    (item: Color) => item.cid === currentElement!.color!.cid
                )
                if (!isDuplicate) {
                    colors.push(currentElement!.color)
                }
            }
            // font
            if (currentElement!.font) {
                const isDuplicate = fonts.some((item: Font) => item.id === currentElement!.font!.id)
                if (!isDuplicate) {
                    fonts.push(currentElement!.font)
                }
            }
            // paper
            if (currentElement!.type === 'paper') {
                expressObject.paper = currentElement!.value
            }
            // liner
            if (currentElement!.type === 'liner') {
                expressObject.liner = currentElement!.value
            }
        }
        expressObject.print = prints
        expressObject.color = colors
        expressObject.font = fonts
    }
    return expressObject
}
